<div mat-dialog-title>
    <div class="d-flex justify-content-between">
        Create New Element Detail
        <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
</div>
<div mat-dialog-content>
    <mat-accordion>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title id="accAccountCodeMaster">
                    <div class="d-flex justify-content-between eip-pt-10 eip-pb-10">
                        <div class="title-container d-flex align-items-center" (click)="$event.stopPropagation();">
                            <mat-button-toggle-group aria-label="Font Style" class="" (change)="ElementTypeChange($event)" [value]="selectedElementType" [hidden]="isEdit">
                                <mat-button-toggle value="newelement">New Element Detail</mat-button-toggle>
                                <mat-button-toggle value="copyelement">Copy Element Details</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="eip-mt-20 eip-mb-10">
                <form [formGroup]="elementDetailsForm" autocomplete="off" class="eip=pt-20">
                    <div class="row" *ngIf="selectedElementType =='newelement'">
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Short Description </mat-label>
                                <input matInput formControlName="elementDetailShortName" required>
                                <mat-error *ngIf="elementDetailsForm.get('elementDetailShortName').hasError('required')">
                                    Short Description is required 
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <mat-form-field style="width: 100%;">
                                <mat-label>Description</mat-label>
                                <input matInput formControlName="elementDetailName" required>
                                <mat-error *ngIf="elementDetailsForm.get('elementDetailName').hasError('required')">
                                    Description is required
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <mat-form-field style="width: 100%;">
                                <mat-label>DED Code</mat-label>
                                <input matInput formControlName="elementDetailDEDCode">
                            </mat-form-field>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <mat-form-field floatLabel="always" appearance="none">
                                <mat-label>Active Status</mat-label>
                                <mat-slide-toggle color="primary" formControlName="elementDetailStatus">
                                </mat-slide-toggle>
                                <textarea matInput hidden></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="selectedElementType =='copyelement'">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <mat-form-field style="width: 100%;">
                                <mat-label>From Element</mat-label>
                                <input [readonly]="true" matInput formControlName="FromElement">
                            </mat-form-field>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <edms-autocomplete [data]="elementList" [form]="elementDetailsForm" controlName="ToElement" textField="dE_Description" label="To Element" error="Please select to Element" (optionSelected)="ToElementChange($event)">
                            </edms-autocomplete>
                        </div>
                    </div>
                    <br>
                </form>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
<div mat-dialog-actions>
    <div class="row justify-content-end flex-grow-1">
        <button (click)="saveElementDetails()" class="btn btn-primary btn-sm" [disabled]="(!elementDetailsForm.valid && selectedElementType =='newelement') || ( selectedElementType =='copyelement' && !ToelementId) " type="submit"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;{{actionButtonText}}</button>&nbsp;
        <button type="button"  (click)="closeDialog()"  class="btn btn-secondary btn-sm" id="btnEDMCancel"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Cancel</button>
    </div>
</div>